import { render, staticRenderFns } from "./MenuPublicHome.vue?vue&type=template&id=816af882"
import script from "./MenuPublicHome.vue?vue&type=script&lang=js"
export * from "./MenuPublicHome.vue?vue&type=script&lang=js"
import style0 from "./MenuPublicHome.vue?vue&type=style&index=0&id=816af882&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports